var _rect, _rect2, _polygon, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.73,
    y: 17.01,
    width: 1.45,
    height: 14.91,
    transform: "translate(30.03 -23.56) rotate(45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.38,
    y: 13.08,
    width: 5.92,
    height: 7.82,
    transform: "translate(0.39 34.91) rotate(-45)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "36.39 17.4 13.39 40.41 10.76 48.57 18.92 45.94 41.92 22.93 36.39 17.4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.58,
    y: 12.53,
    width: 4.49,
    height: 3.33,
    transform: "translate(23.17 -27.54) rotate(45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.f8b1521b3be56978269cbb2d3ec7c066.svg";
export { ForwardRef as ReactComponent };